<template>
  <div>
    <div class="flex flex-col justify-center">
      <p class="headerstyle">เพิ่มประเภทหลักสูตร</p>
      <div class="fromstyle">
        <form @submit.prevent="checkForm">
          <div id="fadeIn" class="error-style" v-if="errors.length">
            <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <vs-input
            class="w-full"
            id="curriculum"
            placeholder="ชื่อประเภทหลักสูตร"
            type="text"
            v-model="curriculum"
            name="curriculum"
            v-debounce:500ms="CheckCurriculumType"
            required
          />

          <select
            class="my-5 custom-select"
            v-model="usertype"
            id="usertype"
            name="usertype"
          >
            <option :value="null" disabled selected>หลักสูตร</option>
            <option>หลักสูตรหลัก</option>
            <option>หลักสูตรเฉพาะกลุ่ม</option>
          </select>

          <div id="fadeIn" v-if="usertype == 'หลักสูตรเฉพาะกลุ่ม'">
            <label id="header">ประเภทของผู้เรียนที่สามารถเข้าเรียนได้</label>

            <multiselect
              class="cus-select"
              v-model="value"
              :options="this.options"
              placeholder="ประเภทผู้เรียน"
              label="name"
              track-by="name"
              :allow-empty="false"
            >
            </multiselect>
          </div>

          <vs-row vs-w="12">
            <vs-col vs-w="12" class="flex justify-center">
              <button
                type="submit"
                value="Submit"
                class="share-btn"
                :disabled="isDisable"
              >
                แก้ไขแบบหลักสูตร
              </button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import Multiselect from "vue-multiselect";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    async checkForm(e) {
      if (this.usertype == "หลักสูตรหลัก") {
        this.value = { code: 1 };
      }
      if (this.errors.length === 0) {
        this.$vs.loading();
        let config = {
          method: "put",
          url: `${baseUrl.baseurl()}/updateCategory_curriculum`,
          data: {
            category_curriculum_id: this.data.category_curriculum_id,
            title: this.curriculum.trimLeft(),
            type: this.usertype,
            organization_id:
              this.usertype == "หลักสูตรหลัก" ? 1 : this.value.code
          }
        };
        axios
          .post(`${baseUrl.baseurl()}/checkCategoryCurriculumUpdateExist`, {
            category_curriculum_id: this.data.category_curriculum_id,
            title: this.curriculum.trimLeft()
          })
          .then(() => {
            axios
              .api(config)
              .then(res => {
                this.$vs.loading.close();
                this.$vs.notify({
                  title: "แก้ไขประเภทหลักสูตร",
                  text: "สำเร็จ",
                  color: "success",
                  icon: "check_box",
                  position: "top-right"
                });
                this.$router.push({ path: "/curriculumType" });
              })
              .catch(error => {
                this.$vs.notify({
                  title: "Error message",
                  text: `${
                    error.response.data.error
                      ? error.response.data.error
                      : error
                  }`,
                  color: "danger",
                  icon: "error",
                  position: "top-right"
                });
                this.isDisable = false;
                this.$vs.loading.close();
              });
          })
          .catch(err => {
            this.errors = [];
            this.isDisable = false;
            this.errors.push(
              err.response.data.error ? err.response.data.error : error
            );
            this.$vs.loading.close();
          });
      }

      if (!this.curriculum) {
        this.errors.push("กรุณากรอกชื่อประเภทคอร์สเรียน");
      }
      if (!this.usertype) {
        this.errors.push("กรุณาเลือกประเภทหลักสูตร");
      }
      if (this.usertype == "หลักสูตรเฉพาะ" && !this.value) {
        this.errors.push("กรุณาเลือกประเภทหน่วยงาน");
      }
    },

    Syncdata() {
      this.curriculum = this.data.title;
      this.usertype = this.data.type;
      this.value = {
        name: this.data.name,
        code: this.data.organization_id
      };
    },

    CheckCurriculumType() {
      if (this.curriculum) {
        axios
          .post(`${baseUrl.baseurl()}/checkCategoryCurriculumUpdateExist`, {
            category_curriculum_id: this.data.category_curriculum_id,
            title: this.curriculum.trimLeft()
          })
          .then(() => {
            this.errors = [];
            this.isDisable = false;
            return;
          })
          .catch(err => {
            this.errors = [];
            this.isDisable = true;
            this.errors.push(err.response.data.error);
          });
      }
    }
  },

  async mounted() {
    this.Syncdata();
    await this.$store.dispatch("general/get_organization_choice");
  },
  data() {
    return {
      curriculum: null,
      usertype: null,
      errors: [],
      value: null,
      isDisable: false
    };
  },
  computed: {
    ...mapGetters({
      options: "general/choice",
      data: "general/editPage"
    })
  },

  components: {
    Multiselect
  }
};
</script>

<style lang="scss" scoped>
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
  &:disabled {
    background-color: gray;
    color: black;
  }
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
</style>

<style lang="scss">
.cus-select {
  font-size: 0.9rem !important;
  margin-bottom: 2rem !important;
}

// .cus-select .multiselect__tags {
//   font-size: .9rem !important;
//   border: 2px solid #0430AD;
// }
</style>
